/* eslint-disable */

import request from '@/utils/request'

export function getListGuestTemplate(query) {
  return request({
    url: '/config-service/v1/guest-note-template/guest-note-template/list',
    method: 'get',
    params: query
  })
}

export function addGuestTemplate(query) {
  return request({
    url: '/config-service/v1/guest-note-template/guest-note-template/add',
    method: 'post',
     data: query
  })
}

export function updateGuestTemplate(query) {
  return request({
    url: '/config-service/v1/guest-note-template/guest-note-template/update',
    method: 'put',
     data: query
  })
}

export function deleteGuestTemplate(query) {
  return request({
    url: '/config-service/v1/guest-note-template/guest-note-template/delete',
    method: 'delete',
    data: query
  })
}
